/** Same values as signup (`signup.component.html`) — used for profile + consistent selects. */
export const COMPANY_SIZE_OPTIONS: readonly { value: string; label: string }[] = [
  { value: '1-10', label: '1-10' },
  { value: '11-50', label: '11-50' },
  { value: '51-200', label: '51-200' },
  { value: '201-500', label: '201-500' },
  { value: '500+', label: '500+' },
];

const ALLOWED = new Set(COMPANY_SIZE_OPTIONS.map((o) => o.value));

export function isAllowedCompanySize(value: string): boolean {
  return ALLOWED.has(String(value ?? '').trim());
}

/**
 * Maps signup / tenant `company.size` and legacy free-text hints onto canonical option values.
 * Unknown non-empty values are returned as-is so the UI can still show them as a "saved" option.
 */
export function normalizeCompanySizeForSelect(raw: string | null | undefined): string {
  const t = String(raw ?? '').trim();
  if (!t) return '';
  if (ALLOWED.has(t)) return t;

  const compact = t.replace(/\s+/g, '');
  if (/^1[-–]5$/i.test(compact) || /^1[-–]10$/i.test(compact)) return '1-10';
  if (/^5[-–]20$/i.test(compact) || /^6[-–]20$/i.test(compact) || /^11[-–]50$/i.test(compact)) return '11-50';
  if (/^20[-–]100$/i.test(compact) || /^51[-–]200$/i.test(compact)) return '51-200';
  if (/^100[-–]500$/i.test(compact) || /^201[-–]500$/i.test(compact)) return '201-500';
  if (/^500\+$/i.test(compact) || /^501\+$/i.test(compact)) return '500+';

  return t;
}
